import React from "react";
import { Alert, Paper, Stack, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import WhiteLabelCompanyAutocomplete from "./WhiteLabelCompanyAutocomplete";

export default function WhiteLabelWorkspaceShell({
  title,
  description,
  companyId,
  onCompanyChange,
  companyHelperText = "Choose a company to load module-specific configuration.",
  selectorDisabled = false,
  error = "",
  actions = null,
  children,
}) {
  const theme = useTheme();

  return (
    <Stack spacing={3}>
      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          p: { xs: 2, md: 2.5 },
          border: `1px solid ${alpha(theme.palette.divider, 0.88)}`,
          bgcolor:
            theme.palette.mode === "dark"
              ? alpha(theme.palette.background.paper, 0.92)
              : alpha(theme.palette.common.white, 0.96),
          boxShadow:
            theme.palette.mode === "dark"
              ? `0 18px 40px ${alpha("#020617", 0.28)}`
              : `0 18px 40px ${alpha("#0f172a", 0.06)}`,
        }}
      >
        <Stack
          direction={{ xs: "column", xl: "row" }}
          spacing={2}
          justifyContent="space-between"
        >
          <Stack spacing={0.75} sx={{ maxWidth: 840 }}>
            <Typography variant="h5" sx={{ fontWeight: 900 }}>
              {title}
            </Typography>
            <Typography variant="body1" sx={{ color: "text.secondary" }}>
              {description}
            </Typography>
          </Stack>
          {actions}
        </Stack>

        <Stack sx={{ mt: 2.25 }}>
          <WhiteLabelCompanyAutocomplete
            value={companyId}
            onChange={onCompanyChange}
            helperText={companyHelperText}
            disabled={selectorDisabled}
            required
          />
        </Stack>
      </Paper>

      {error ? <Alert severity="error">{error}</Alert> : null}

      {children}
    </Stack>
  );
}
